import { useEffect, useState } from "react";

// Lightweight, compatible replacement for `use-detect-print`.
// Uses beforeprint/afterprint events and matchMedia when available.
export default function useDetectPrint() {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    const handleBeforePrint = () => setIsPrinting(true);
    const handleAfterPrint = () => setIsPrinting(false);

    if (typeof window === "undefined") return;

    // window.matchMedia('print') is supported in modern browsers
    const mediaQuery = window.matchMedia && window.matchMedia("print");
    if (mediaQuery && typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", (m) => {
        setIsPrinting(m.matches);
      });
    } else if (mediaQuery && typeof mediaQuery.addListener === "function") {
      // older API
      mediaQuery.addListener((m) => setIsPrinting(m.matches));
    }

    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
      if (mediaQuery && typeof mediaQuery.removeEventListener === "function") {
        mediaQuery.removeEventListener("change", () => {});
      } else if (mediaQuery && typeof mediaQuery.removeListener === "function") {
        mediaQuery.removeListener(() => {});
      }
    };
  }, []);

  return isPrinting;
}
